import React from "react";
import PropTypes from "prop-types";
import { constants } from "../../resource/constants";
import {
  defaultRadiusOption,
  radiusOptions,
  gender,
  defaultGenderOption
} from "../../resource/find-providers";

const ProviderSearchForm = ({
  components,
  onInputsChange,
  onRadiusChange,
  onSpecialtyChange,
  onGenderChange,
  data,
  onClearFilters,
  isFiltersCollapsed
}) => {
  const wrapAddLabel = (text, child, className) => (
    <div className={className}>
      <components.Label text={text} />
      {child}
    </div>
  );
  return (
    <>
      <div
        className={`search-form-wrapper-web-sdk${
          isFiltersCollapsed ? " collapsed" : ""
        }`}
      >
        <div className='websdk-flex websdk-flex-col'>
          <div className='websdk-flex websdk-flex-wrap websdk-space-x-1'>
            {wrapAddLabel(
              "Providers last name",
              <components.Input
                onChange={onInputsChange}
                placeholder='Enter last name'
                name='last'
                value={data.last}
              />,
              "xs:websdk-w-full sm:websdk-w-175px"
            )}
            {wrapAddLabel(
              "Zip",
              <components.Input
                onChange={onInputsChange}
                placeholder='Enter zip'
                name='zip'
                value={data.zip}
              />,
              "xs:websdk-w-full sm:websdk-w-115px"
            )}
            {wrapAddLabel(
              "Radius (mi)",
              <components.Select
                onChange={onRadiusChange}
                options={radiusOptions}
                fieldAttributes={defaultRadiusOption}
                name='radius'
                value={data.radius}
              />,
              "xs:websdk-w-full sm:websdk-w-110px"
            )}
            {wrapAddLabel(
              "Specialty",
              <components.Autocomplete
                defaultValue={data?.specialty?.label}
                handleChange={onSpecialtyChange}
                suggestions={constants.providerSpecialties}
              />,
              "xs:websdk-w-full sm:websdk-w-200px"
            )}
            {wrapAddLabel(
              "Provider gender",
              <components.Select
                fieldAttributes={defaultGenderOption}
                onChange={onGenderChange}
                value={data.gender}
                options={gender}
              />,
              "xs:websdk-w-full sm:websdk-w-175px"
            )}
          </div>
          <div className='websdk-flex websdk-justify-end clear-web-sdk'>
            <div className='websdk-w-auto'>
              <components.Text label='Clear filters' onClick={onClearFilters} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ProviderSearchForm.propTypes = {
  isFiltersCollapsed: PropTypes.bool,
  components: PropTypes.shape({
    Label: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
    Select: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
    Input: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
    Autocomplete: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
      .isRequired
  }).isRequired,
  onInputsChange: PropTypes.func,
  onRadiusChange: PropTypes.func,
  onSpecialtyChange: PropTypes.func,
  onGenderChange: PropTypes.func,
  onClearFilters: PropTypes.func,
  data: PropTypes.object
};

export default ProviderSearchForm;
